import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Geosuggest from '@ubilabs/react-geosuggest';
import DocumentUpload from '../../DocumentUpload';
import notAvailable from '../../../../assets/images/not-available.png';
import greenCheck from '../../../../assets/images/green-check.png';
import clock from '../../../../assets/images/icons/clock.svg';
import suitcase from '../../../../assets/images/icons/suitcaseGray.svg';
import mapPin from '../../../../assets/images/icons/map-pin.png';
import airplane from '../../../../assets/images/icons/airplaneGray.svg';
import clockPerson from '../../../../assets/images/icons/clockPerson.svg';
import dollarSign from '../../../../assets/images/icons/dollarGray.svg';
import blueInfoIcon from '../../../../assets/images/icons/blue-info-icon.svg';
import redWarningIcon from '../../../../assets/images/icons/red-warning-icon.svg';
import SearchIcon from '../../../../assets/images/search-icon.svg';
var InterestDetails = /*#__PURE__*/function (_Component) {
  function InterestDetails(props) {
    var _this;
    _classCallCheck(this, InterestDetails);
    _this = _callSuper(this, InterestDetails, [props]);
    _this.tagTypes = {
      area_of_expertises: 'Functional areas',
      therapeutic_areas: 'Therapeutic areas',
      therapies: 'Product Technologies',
      development_phases: 'Development phases',
      disease_codes: 'Disease codes',
      regulatory_pathways: 'Regulatory pathways',
      degrees: 'Education',
      accreditations: 'Certifications',
      languages: 'Languages'
    };
    _this.state = {
      pendingTagIds: {}
    };
    _this.handleTogglePendingTag = _this.handleTogglePendingTag.bind(_this);
    _this.handleSavePendingTags = _this.handleSavePendingTags.bind(_this);
    return _this;
  }
  _inherits(InterestDetails, _Component);
  return _createClass(InterestDetails, [{
    key: "handleTogglePendingTag",
    value: function handleTogglePendingTag(type, id) {
      this.setState(function (prevState) {
        var current = prevState.pendingTagIds[type] || [];
        var updated = current.includes(id) ? current.filter(function (x) {
          return x !== id;
        }) : [].concat(_toConsumableArray(current), [id]);
        return {
          pendingTagIds: _objectSpread(_objectSpread({}, prevState.pendingTagIds), {}, _defineProperty({}, type, updated))
        };
      });
    }
  }, {
    key: "handleSavePendingTags",
    value: function handleSavePendingTags() {
      var handleAddExpertiseTags = this.props.handleAddExpertiseTags;
      var pendingTagIds = this.state.pendingTagIds;
      handleAddExpertiseTags(pendingTagIds);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        addingTagsSaving = _this$props.addingTagsSaving,
        addingTagsError = _this$props.addingTagsError;
      if (prevProps.addingTagsSaving && !addingTagsSaving && !addingTagsError) {
        this.setState({
          pendingTagIds: {}
        });
      }
    }
  }, {
    key: "requiredExpertisePresent",
    value: function requiredExpertisePresent() {
      var project = this.props.project;
      return Object.keys(this.tagTypes).reduce(function (agg, type) {
        return agg.concat((project === null || project === void 0 ? void 0 : project.missing_priority_tags[type]) || []).concat((project === null || project === void 0 ? void 0 : project.matching_priority_tags[type]) || []);
      }, []).length;
    }
  }, {
    key: "preferredExpertisePresent",
    value: function preferredExpertisePresent() {
      var project = this.props.project;
      return Object.keys(this.tagTypes).reduce(function (agg, type) {
        return agg.concat((project === null || project === void 0 ? void 0 : project.missing_preferred_tags[type]) || []).concat((project === null || project === void 0 ? void 0 : project.matching_preferred_tags[type]) || []);
      }, []).length;
    }
  }, {
    key: "officeLocationText",
    value: function officeLocationText() {
      var project = this.props.project;
      var projectLocation = '';
      switch (project === null || project === void 0 ? void 0 : project.work_location.toLowerCase()) {
        case 'office':
          projectLocation += 'In Office';
          if (project !== null && project !== void 0 && project.office_days) {
            projectLocation = "".concat(projectLocation, " at least ").concat(project === null || project === void 0 ? void 0 : project.office_days, " days / week");
          }
          if (project !== null && project !== void 0 && project.office_location) {
            projectLocation += " at ".concat(project === null || project === void 0 ? void 0 : project.office_location);
          }
          return projectLocation;
        case 'remote':
          return project !== null && project !== void 0 && project.remote_preferred_location ? "Remote, ideally from ".concat(project === null || project === void 0 ? void 0 : project.remote_preferred_location) : 'Remote';
        case 'hybrid':
          projectLocation += 'Hybrid';
          if (project !== null && project !== void 0 && project.office_days) {
            projectLocation = "".concat(projectLocation, ", in office ").concat(project === null || project === void 0 ? void 0 : project.office_days, " days / week ");
          }
          if (project !== null && project !== void 0 && project.office_location) {
            projectLocation += " at ".concat(project === null || project === void 0 ? void 0 : project.office_location);
          }
          return projectLocation;
        case 'both':
          return "Office and remote. At least ".concat(project === null || project === void 0 ? void 0 : project.office_days, " days in the office (").concat(project === null || project === void 0 ? void 0 : project.office_location, ").");
        case 'not sure':
          return 'Workplace Type - Unsure';
        default:
          return 'Work preference';
      }
    }
  }, {
    key: "renderProjectTags",
    value: function renderProjectTags(priority, tagType, label) {
      var _this$props2 = this.props,
        project = _this$props2.project,
        locallyAddedTagIds = _this$props2.locallyAddedTagIds;
      var serverMatchingTags = (priority ? project === null || project === void 0 ? void 0 : project.matching_priority_tags[tagType] : project === null || project === void 0 ? void 0 : project.matching_preferred_tags[tagType]) || [];
      var serverMissingTags = (priority ? project === null || project === void 0 ? void 0 : project.missing_priority_tags[tagType] : project === null || project === void 0 ? void 0 : project.missing_preferred_tags[tagType]) || [];
      var addedIds = priority && locallyAddedTagIds ? locallyAddedTagIds[tagType] || [] : [];
      var matchingTags = addedIds.length ? [].concat(_toConsumableArray(serverMatchingTags), _toConsumableArray(serverMissingTags.filter(function (tag) {
        return addedIds.includes(tag.id);
      }))) : serverMatchingTags;
      var missingTags = addedIds.length ? serverMissingTags.filter(function (tag) {
        return !addedIds.includes(tag.id);
      }) : serverMissingTags;
      if (!(matchingTags.length + missingTags.length)) return null;
      return /*#__PURE__*/React.createElement(Fragment, {
        key: "".concat(label, "-tags")
      }, /*#__PURE__*/React.createElement("h6", {
        className: "expertise-tag-header"
      }, label), matchingTags.length ? /*#__PURE__*/React.createElement(Fragment, {
        key: "".concat(label, "-matching-tags")
      }, /*#__PURE__*/React.createElement("img", {
        className: "green-check",
        src: greenCheck,
        alt: "Matched expertise"
      }), matchingTags.map(function (tag) {
        return /*#__PURE__*/React.createElement("span", {
          key: tag.name,
          className: "badge small matching-tag"
        }, tag.name);
      })) : '', missingTags.length ? /*#__PURE__*/React.createElement(Fragment, {
        key: "".concat(label, "-missing-tags")
      }, priority ? /*#__PURE__*/React.createElement("img", {
        className: "not-available",
        src: notAvailable,
        alt: "Missing expertise"
      }) : '', missingTags.map(function (tag) {
        return /*#__PURE__*/React.createElement("span", {
          key: tag.name,
          className: "badge small ".concat(priority ? 'missing-tag' : 'normal-tag')
        }, tag.name);
      })) : '');
    }
  }, {
    key: "renderWorkAuthorization",
    value: function renderWorkAuthorization() {
      var _this$props3 = this.props,
        project = _this$props3.project,
        handleToggleCheckbox = _this$props3.handleToggleCheckbox,
        submitAttempted = _this$props3.submitAttempted,
        submitted = _this$props3.submitted,
        checkboxes = _this$props3.checkboxes;
      if (!(project !== null && project !== void 0 && project.us_work_authorization_required)) return null;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Work Authorization"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "Will you now or in the future require sponsorship to work within the United States?"), submitted ? '✅ No' : /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3 "
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "work-authorization-checkbox-yes",
        className: "work-authorization-checkbox-label"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "work-authorization-checkbox-yes",
        name: "work-authorization-checkbox",
        value: "Yes",
        onChange: handleToggleCheckbox('work_authorization', false)
      }), "Yes"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "work-authorization-checkbox-no",
        className: "work-authorization-checkbox-label ms-2"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "work-authorization-checkbox-no",
        name: "work-authorization-checkbox",
        value: "No",
        onChange: handleToggleCheckbox('work_authorization', true)
      }), "No"), submitAttempted && !checkboxes.work_authorization ? /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Work authorization is required before continuing to the next step") : ''));
    }
  }, {
    key: "renderHourlyRateSection",
    value: function renderHourlyRateSection() {
      var _this$props4 = this.props,
        project = _this$props4.project,
        handleTextChange = _this$props4.handleTextChange,
        submitAttempted = _this$props4.submitAttempted,
        repView = _this$props4.repView,
        requestedHourlyRate = _this$props4.requestedHourlyRate;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Hourly Rate"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "Considering the scope of the project, seniority and responsibilities below, what hourly rate range would you consider for this project?"), this.renderProjectTags(false, 'levels', 'Seniority'), /*#__PURE__*/React.createElement("h6", null, "Role Responsibilities"), /*#__PURE__*/React.createElement("ul", null, project === null || project === void 0 ? void 0 : project.responsibilities.map(function (resp) {
        return /*#__PURE__*/React.createElement("li", {
          key: resp
        }, resp);
      })), /*#__PURE__*/React.createElement("h6", null, "Your preferred hourly rate (in USD)"), /*#__PURE__*/React.createElement("div", {
        className: "hourly-rates-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "requested-hourly-rate me-2"
      }, /*#__PURE__*/React.createElement("img", {
        src: dollarSign,
        alt: "Hourly rate in dollars"
      }), /*#__PURE__*/React.createElement("input", {
        id: "requested-hourly-rate",
        type: "text",
        onChange: handleTextChange('requestedHourlyRate'),
        pattern: "[0-9]+",
        value: requestedHourlyRate,
        readOnly: repView
      }))), submitAttempted && !requestedHourlyRate && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please enter your preferred hourly rate."), submitAttempted && !requestedHourlyRate.match(/^[0-9]+$/) && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please enter a whole number as an hourly rate."), project !== null && project !== void 0 && project.consultant_take_home_minimum && project !== null && project !== void 0 && project.consultant_take_home_maximum ? /*#__PURE__*/React.createElement("div", {
        className: "hourly-rate-info"
      }, /*#__PURE__*/React.createElement("img", {
        src: blueInfoIcon,
        alt: "Info"
      }), "A typical range for similar roles is", /*#__PURE__*/React.createElement("span", {
        className: "demibold ms-2"
      }, "$", project === null || project === void 0 ? void 0 : project.consultant_take_home_minimum, ' ', "- $", project === null || project === void 0 ? void 0 : project.consultant_take_home_maximum), ", depending on experience") : '');
    }
  }, {
    key: "renderTaxReporting",
    value: function renderTaxReporting() {
      var _this$props5 = this.props,
        submitted = _this$props5.submitted,
        handleToggleCheckbox = _this$props5.handleToggleCheckbox,
        submitAttempted = _this$props5.submitAttempted,
        checkboxes = _this$props5.checkboxes;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Tax reporting"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "Consultants for this role are responsible for their own federal payroll taxes, also known as self-employment tax. Clora will provide you with a \xA0", /*#__PURE__*/React.createElement("span", {
        className: "demibold"
      }, "1099"), "."), submitted ? '✅ Accepted' : /*#__PURE__*/React.createElement("label", {
        htmlFor: "tax-reporting-checkbox",
        className: "tax-reporting-checkbox-label"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "tax-reporting-checkbox",
        onChange: handleToggleCheckbox('tax_reporting')
      }), "I understand"), submitAttempted && !checkboxes.tax_reporting && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please acknowledge before continuing to the next step"));
    }
  }, {
    key: "renderMissingTagWarning",
    value: function renderMissingTagWarning() {
      var _this2 = this;
      var _this$props6 = this.props,
        project = _this$props6.project,
        locallyAddedTagIds = _this$props6.locallyAddedTagIds,
        addingTagsSaving = _this$props6.addingTagsSaving,
        addingTagsError = _this$props6.addingTagsError;
      var pendingTagIds = this.state.pendingTagIds;
      var addableTypes = Object.keys(locallyAddedTagIds || {});
      var missingByType = addableTypes.reduce(function (acc, type) {
        var missing = ((project === null || project === void 0 ? void 0 : project.missing_priority_tags[type]) || []).filter(function (tag) {
          return !(locallyAddedTagIds[type] || []).includes(tag.id);
        });
        if (missing.length > 0) acc[type] = missing;
        return acc;
      }, {});
      var hasMissing = Object.keys(missingByType).length > 0;
      if (!hasMissing) return null;
      var hasPending = Object.values(pendingTagIds).some(function (ids) {
        return ids.length > 0;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "missing-expertise-warning"
      }, /*#__PURE__*/React.createElement("img", {
        src: redWarningIcon,
        alt: "Warning"
      }), /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, /*#__PURE__*/React.createElement("div", {
        className: "heading"
      }, "You must have the required expertise to submit this application. Select the tags below that apply to your experience to add them to your profile."), Object.keys(missingByType).map(function (type) {
        return /*#__PURE__*/React.createElement("div", {
          key: type,
          className: "missing-tag-type mt-2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "missing-tag-type-label"
        }, _this2.tagTypes[type]), /*#__PURE__*/React.createElement("div", {
          className: "missing-tag-checkboxes"
        }, missingByType[type].map(function (tag) {
          var checked = (pendingTagIds[type] || []).includes(tag.id);
          var inputId = "missing-tag-".concat(type, "-").concat(tag.id);
          return /*#__PURE__*/React.createElement("label", {
            key: tag.id,
            htmlFor: inputId,
            className: "missing-tag-checkbox-label"
          }, /*#__PURE__*/React.createElement("input", {
            type: "checkbox",
            id: inputId,
            checked: checked,
            onChange: function onChange() {
              return _this2.handleTogglePendingTag(type, tag.id);
            }
          }), /*#__PURE__*/React.createElement("span", null, tag.name));
        })));
      }), addingTagsError && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small mt-2"
      }, addingTagsError), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-sm mt-3",
        onClick: this.handleSavePendingTags,
        disabled: !hasPending || addingTagsSaving
      }, addingTagsSaving ? 'Saving…' : 'Add to my profile')));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props7 = this.props,
        project = _this$props7.project,
        uploadResumeUrl = _this$props7.uploadResumeUrl,
        csrfToken = _this$props7.csrfToken,
        resume = _this$props7.resume,
        checkboxes = _this$props7.checkboxes,
        submitted = _this$props7.submitted,
        missingRequiredExpertise = _this$props7.missingRequiredExpertise,
        handleToggleCheckbox = _this$props7.handleToggleCheckbox,
        handleUpdateResume = _this$props7.handleUpdateResume,
        submitAttempted = _this$props7.submitAttempted,
        repView = _this$props7.repView,
        handleTextChange = _this$props7.handleTextChange,
        location = _this$props7.location,
        openToRelocation = _this$props7.openToRelocation,
        isHybridOrInOffice = _this$props7.isHybridOrInOffice,
        handleOpenToggleCheckbox = _this$props7.handleOpenToggleCheckbox;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide start-application p-2 px-md-2 py-md-3"
      }, /*#__PURE__*/React.createElement("h2", null, repView ? "".concat(project === null || project === void 0 ? void 0 : project.consultant_name, " - ") : 'Submit an ', "Application for", ' ', project === null || project === void 0 ? void 0 : project.name), /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-3 mb-2"
      }, "Your Resume"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-2"
      }, "This resume will be included with your application and shared with clients."), repView ? /*#__PURE__*/React.createElement("a", {
        href: resume.document_url,
        target: "_blank",
        rel: "noreferrer"
      }, resume.document_file_name) : /*#__PURE__*/React.createElement(DocumentUpload, {
        location: "Consultant Interest",
        buttonStyle: "button",
        prompt: "Upload Resume",
        uploadDocumentUrl: uploadResumeUrl,
        document: resume,
        csrfToken: csrfToken,
        documentType: "resume",
        handleAfterUpload: function handleAfterUpload(r) {
          return handleUpdateResume(r);
        },
        skipParsing: true
      }), submitAttempted && (!resume || Object.keys(resume).length === 0) && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please upload a resume"), this.requiredExpertisePresent() ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Required expertise"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-2"
      }, "This project requires candidates to have the following expertise as the minimum requirements for consideration."), Object.keys(this.tagTypes).map(function (type) {
        return _this3.renderProjectTags(true, type, _this3.tagTypes[type]);
      })) : '', missingRequiredExpertise ? this.renderMissingTagWarning() : '', this.preferredExpertisePresent() ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Preferred expertise"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "The client would prefer to see these skill sets, but they are not required. Let\u2019s check these optional criteria against your expertise."), Object.keys(this.tagTypes).map(function (type) {
        return _this3.renderProjectTags(false, type, _this3.tagTypes[type]);
      })) : '', /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, (project === null || project === void 0 ? void 0 : project.employment_type) === 'full_time' ? 'Logistics' : 'Availability'), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "The client requires candidates who can meet the following requirements:"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-8"
      }, project !== null && project !== void 0 && project.approximate_start_date_local ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text"
      }, /*#__PURE__*/React.createElement("img", {
        src: suitcase,
        alt: "Suitcase"
      }), "Scheduled to start ".concat(project === null || project === void 0 ? void 0 : project.approximate_start_date_local)) : ''), project !== null && project !== void 0 && project.avg_time_required_range && (project === null || project === void 0 ? void 0 : project.employment_type) === 'consulting' ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text"
      }, /*#__PURE__*/React.createElement("img", {
        src: clock,
        alt: "Hours required"
      }), (project === null || project === void 0 ? void 0 : project.avg_time_required_text) || "".concat(project === null || project === void 0 ? void 0 : project.avg_time_required_range, " hours / wk")) : '', project !== null && project !== void 0 && project.duration_range && (project === null || project === void 0 ? void 0 : project.employment_type) === 'consulting' ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text duration"
      }, /*#__PURE__*/React.createElement("img", {
        src: clockPerson,
        alt: "Duration of project"
      }), (project === null || project === void 0 ? void 0 : project.duration_text) || ((project === null || project === void 0 ? void 0 : project.duration_range) === 1 ? "".concat(project === null || project === void 0 ? void 0 : project.duration_range, " month") : "".concat(project === null || project === void 0 ? void 0 : project.duration_range, " months"))) : '', project !== null && project !== void 0 && project.work_location ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text"
      }, /*#__PURE__*/React.createElement("img", {
        src: mapPin,
        alt: "Work Location"
      }), "".concat(project === null || project === void 0 ? void 0 : project.office_and_worktype_information)) : '', project !== null && project !== void 0 && project.days_of_travel && project !== null && project !== void 0 && project.travel_locations ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text"
      }, /*#__PURE__*/React.createElement("img", {
        src: airplane,
        alt: "Travel"
      }), "Travel Requirements - Travel to ".concat(project === null || project === void 0 ? void 0 : project.travel_locations, " ").concat(project === null || project === void 0 ? void 0 : project.days_of_travel, " day(s) per month")) : '', !(project !== null && project !== void 0 && project.days_of_travel) && project !== null && project !== void 0 && project.travel_locations ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text"
      }, /*#__PURE__*/React.createElement("img", {
        src: airplane,
        alt: "Travel"
      }), "Travel Requirements - ".concat(project === null || project === void 0 ? void 0 : project.travel_locations)) : '', submitted ? '✅ Accepted' : /*#__PURE__*/React.createElement("label", {
        htmlFor: "availability-checkbox",
        className: "availability-checkbox-label"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "availability-checkbox",
        onChange: handleToggleCheckbox('availability')
      }), "I understand"), submitAttempted && !checkboxes.availability && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please acknowledge before continuing to the next step"), isHybridOrInOffice && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", {
        className: "uppercase-demibold mt-4"
      }, "Hybrid or In Office "), submitted ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text mt-3"
      }, /*#__PURE__*/React.createElement("img", {
        src: mapPin,
        alt: "Work Location"
      }), "Consultant Location: ".concat(location || 'Not specified')) : /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement("h6", null, "Your Location"), /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }, /*#__PURE__*/React.createElement(Geosuggest, {
        initialValue: location,
        suggestItemClassName: "geosuggest-font",
        inputClassName: "input-base",
        placeholder: "Type your current location",
        onSuggestSelect: function onSuggestSelect(obj) {
          return obj && handleTextChange('location')(obj.label);
        }
      }))), submitted ? /*#__PURE__*/React.createElement("div", {
        className: "availability-text mb-3"
      }, /*#__PURE__*/React.createElement("img", {
        src: airplane,
        alt: "Travel"
      }), openToRelocation ? '✅  I am open to Relocation' : '❌  I am not open to Relocation') : /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column mb-3 mt-2"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "open-to-relocation",
        className: "custom-checkbox-container"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "open-to-relocation",
        name: "open-to-relocation",
        className: "checkbox-box",
        checked: openToRelocation,
        onChange: handleOpenToggleCheckbox
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(checkboxes !== null && checkboxes !== void 0 && checkboxes.openToRelocation ? 'active' : '')
      }, "I am open to Relocation.")), submitAttempted && location === '' && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, "Please enter your current location and check the box if you are open to relocation."))), (project === null || project === void 0 ? void 0 : project.employment_type) === 'consulting' ? this.renderHourlyRateSection() : '', (project === null || project === void 0 ? void 0 : project.employment_type) === 'consulting' ? this.renderTaxReporting() : this.renderWorkAuthorization(), submitAttempted && missingRequiredExpertise && /*#__PURE__*/React.createElement("div", {
        className: "warning-text small"
      }, /*#__PURE__*/React.createElement("br", null), "You must have the required expertise in order to submit this application.", /*#__PURE__*/React.createElement("br", null)));
    }
  }]);
}(Component);
InterestDetails.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    consultant_name: PropTypes.string,
    avg_time_required_range: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    duration_range: PropTypes.string,
    days_of_travel: PropTypes.number,
    approximate_start_date_local: PropTypes.string,
    remote_preferred_location: PropTypes.string,
    office_days: PropTypes.number,
    work_location: PropTypes.string,
    office_location: PropTypes.string,
    responsibilities: PropTypes.arrayOf(PropTypes.string),
    matching_priority_tags: PropTypes.shape({}),
    matching_preferred_tags: PropTypes.shape({}),
    missing_priority_tags: PropTypes.shape({}),
    missing_preferred_tags: PropTypes.shape({}),
    consultant_take_home_minimum: PropTypes.number,
    consultant_take_home_maximum: PropTypes.number
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string,
  resume: PropTypes.shape({}),
  missingRequiredExpertise: PropTypes.bool,
  handleUpdateResume: PropTypes.func,
  handleToggleCheckbox: PropTypes.func,
  handleOpenToggleCheckbox: PropTypes.func,
  handleTextChange: PropTypes.func,
  profilePath: PropTypes.string,
  submitAttempted: PropTypes.bool,
  submitted: PropTypes.bool.isRequired,
  requestedHourlyRate: PropTypes.string,
  checkboxes: PropTypes.shape({}).isRequired,
  repView: PropTypes.bool,
  locallyAddedTagIds: PropTypes.shape({}),
  handleAddExpertiseTags: PropTypes.func,
  addingTagsSaving: PropTypes.bool,
  addingTagsError: PropTypes.string
};
InterestDetails.defaultProps = {
  uploadResumeUrl: '',
  resume: {},
  missingRequiredExpertise: false,
  handleUpdateResume: function handleUpdateResume() {},
  handleToggleCheckbox: function handleToggleCheckbox() {},
  handleTextChange: function handleTextChange() {},
  handleOpenToggleCheckbox: function handleOpenToggleCheckbox() {},
  profilePath: '',
  submitAttempted: false,
  requestedHourlyRate: '',
  repView: false,
  locallyAddedTagIds: {},
  handleAddExpertiseTags: function handleAddExpertiseTags() {},
  addingTagsSaving: false,
  addingTagsError: null
};
export default InterestDetails;